<template>
  <v-container fluid>
    <v-card-title class="teal lighten-3 accent-4 white--text">
      Pedidos en Confirmacion
      <v-spacer />
      <v-col cols="12" md="4">
        <v-text-field
          @input="filtrarItems"
          v-model="search"
          append-icon="mdi-magnify"
          label="Búsqueda"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-card-title>

    <v-tabs v-model="selectedTab" color="teal lighten-3 accent-4" left>
      <v-tab
        v-for="(sucursal, index) in itemsSucursalesDisponibles"
        :key="index"
      >
        <div v-if="(sucursal, index) in ordenSucursales" :key="index"></div>
        <div>
          {{ sucursal.sucursal }}
        </div>
      </v-tab>
      <v-tab-item
        :disabled="true"
        v-for="(sucursal, index) in itemsNombre"
        :key="index"
      >
        <v-data-table
          :headers="headers"
          :items="selectedItems"
          :search="search"
          v-model="selectedPedidos"
          checkbox-color="blue darken-1"
          :footer-props="{
            'items-per-page-text': 'Pedidos por página',
            'items-per-page-all-text': 'Todos',
          }"
          :header-props="{ 'sort-by-text': 'Ordenar por' }"
          :item-class="itemRowBackgroundPrioridad"
          no-data-text="No se encontraron pedidos"
          no-results-text="No se encontraron pedidos"
          @dblclick:row="selectPedido"
          @current-items="currentItems"
          @click:row="abrirVistaPreparacion"
        >
          <!-- Columna de Lista plegable de productos -->
          <template v-slot:[`item.lista_productos`]="{ item }">
            <v-list-group v-bind:class="itemRowBackground(item)">
              <template v-slot:activator> </template>
              <v-list-item
                v-for="producto in item.productos.lista_productos"
                :key="producto.codigo"
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{
                      producto.codigo +
                      " " +
                      producto.nombre +
                      ": " +
                      producto.cantidad
                    }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>
          <template v-slot:[`item.localizacion.zona`]="{ item }">
            {{ formatearTexto(item.localizacion?.zona) }}
          </template>
          <!-- Columna de total -->
          <template v-slot:[`item.total`]="{ item }">
            {{ "$" + formatoPrecio(item.total) }}
          </template>
          <!-- Columna de antiguedad -->
          <template v-slot:[`item.fecha_creacion`]="{ item }">
            {{ getAntiguedad(item.fecha_creacion) }}
          </template>
          <!-- Columna de discrepancias -->
          <template v-slot:[`item.discrepancias`]="{ item }">
            <div v-if="item.discrepancias === 'Sin discrepancias'">
              Sin discrepancias
            </div>
            <v-list-group v-else v-bind:class="itemRowBackground(item)">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <v-btn icon color="warning" text>
                      <v-icon dark> mdi-alert-outline </v-icon>
                    </v-btn>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="discrepancia in crearListaDiscrepancias(
                  item.discrepancias,
                )"
                :key="discrepancia"
                no-action
              >
                <v-list-item-content>
                  <v-list-item-title>
                    {{ discrepancia }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </template>
          <!-- Columna de Lista plegable de facturas -->
          <template v-slot:[`item.facturas`]="{ item }">
            <div v-if="item.facturas.length != 0">
              <div v-if="item.facturas.length === 1">
                {{ item.facturas[0] }}
              </div>
              <v-list-group
                v-if="item.facturas.length > 1"
                v-bind:class="itemRowBackground(item)"
              >
                <template v-slot:activator> </template>
                <v-list-item v-for="factura in item.facturas" :key="factura">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ factura }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </div>
            <div v-else>Sin facturas</div>
            <!-- <div v-if="item.facturas.length === 0">Sin facturaszz</div>
              <div v-else>{{ item.facturas[0] }}</div> -->
          </template>
          <!-- Columna de estado -->
          <template v-slot:[`item.estado`]="{ item }">
            <v-chip color="primary" small>
              {{ item.estado }}
            </v-chip>
          </template>

          <template v-slot:[`item.necesitaRevision`]="{ item }">
            <v-chip v-if="item.necesitaRevision" color="red" small>
              {{ item.necesitaRevision }}
            </v-chip>
          </template>

          <!-- Columna de avanzar a: -->
          <template v-slot:[`item.avanzar_a`]="{ item }">
            <div
              v-if="item.estado === 'Cancelado' || item.estado === 'Entregado'"
            >
              N/A
            </div>

            <v-btn v-else @click="confirmarAvanzarPedido(item)" x-small>
              {{ getSiguienteEstado(item).text }}
            </v-btn>
          </template>
          <!-- Columna de acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <template v-if="arrayComentariosNuevos.includes(item.id)">
              <v-badge color="red" dot overlap>
                <AccionesPedido
                  :item="item"
                  :usuarios="usuarios"
                  @pedidoModificado="pedidoModificado"
                />
              </v-badge>
            </template>
            <template v-else>
              <AccionesPedido
                :item="item"
                :usuarios="usuarios"
                @pedidoModificado="pedidoModificado"
              />
            </template>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
    <!-- Dialogo para abrir vista de detalles de un pedido de confirmacion -->
    <v-dialog
      v-model="abrirDetallesPreparacion"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="text-center">
          <v-spacer></v-spacer>
          <v-btn
            icon
            color="blue darken-1"
            text
            @click="cerrarDialogDetallesConfirmacion()"
          >
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6">
              <h3>Detalles del pedido</h3>
              <p><strong>ID:</strong> {{ pedidoSeleccionado?.id }}</p>
              <p>
                <strong> Cliente:</strong> {{ pedidoSeleccionado?.cliente }}
              </p>
              <p>
                <strong>Zona:</strong>
                {{
                  formatearTexto(pedidoSeleccionado?.localizacion?.zona) ||
                  pedidoSeleccionado?.localizacion?.zona
                }}
              </p>
              <p>
                <strong>Vendedor:</strong> {{ pedidoSeleccionado?.vendedor }}
              </p>
              <p>
                <strong>Observaciones:</strong>
                {{ pedidoSeleccionado?.observaciones }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex align-center justify-center">
              <div class="d-flex flex-column align-center justify-center">
                <div
                  v-if="
                    pedidoSeleccionado?.estado === 'Cancelado' ||
                    pedidoSeleccionado?.estado === 'Entregado'
                  "
                >
                  N/A
                </div>
                <v-btn
                  @click="confirmarAvanzarPedido(pedidoSeleccionado)"
                  x-small
                >
                  confirmar y avanzar a:
                  {{ getSiguienteEstadoTexto(pedidoSeleccionado) }}
                </v-btn>
                <v-btn
                  x-small
                  class="my-7"
                  color="primary"
                  @click="generarComentariosProductos()"
                  >Crear comentarios faltantes</v-btn
                >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-large
                      color="primary"
                      @click="abrirEscaneoProductos"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon class="ml-2">mdi-barcode-scan</v-icon>
                    </v-btn>
                  </template>
                  <span>Escanear con cámara - Mantén el código estable</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      class="ml-2 my-2"
                      color="secondary"
                      @click="abrirEscaneoProductosManual"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left small>mdi-keyboard</v-icon>
                      Ingresar manualmente
                    </v-btn>
                  </template>
                  <span>Escribir código manualmente si el escaneo falla</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <v-card>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h3>Comentarios nuevos</h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <h3>Comentarios</h3>
                  <div
                    v-if="comentariosDelPedido.length === 0"
                    class="text-grey text-center py-4"
                  >
                    No hay comentarios
                  </div>

                  <div
                    v-else
                    class="d-flex flex-column ga-2"
                    style="max-height: 300px; overflow-y: auto"
                  >
                    <div
                      v-for="(comentario, i) in comentariosDelPedido"
                      :key="i"
                      class="chat-bubble ml-4"
                    >
                      <strong>Comentario: </strong>
                      {{ comentario.texto_comentario }}
                      <br />
                      <strong>Realizado por:</strong>
                      {{ getVendedor(comentario.usuario) }} <br />
                      <strong>Fecha: </strong>
                      <small class="text-grey">{{
                        getFechaLegible(comentario.fecha_creacion)
                      }}</small>
                      <v-divider class="my-2" color="grey"></v-divider>
                    </div>
                  </div>

                  <v-btn
                    class="d-flex align-center justify-center"
                    @click="agregarComentario = true"
                    color="primary"
                  >
                    Agregar comentario
                  </v-btn>
                  <v-col cols="12" v-if="agregarComentario">
                    <v-textarea
                      v-model="nuevoComentario"
                      label="Agregar comentario"
                      outlined
                    ></v-textarea>
                    <v-btn color="primary" @click="crearComentario()">
                      <v-icon>mdi-send</v-icon>
                      Enviar
                    </v-btn>
                  </v-col>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>

          <v-divider class="my-4"></v-divider>

          <v-menu
            v-model="tooltipVisible"
            :position-x="x"
            :position-y="y"
            absolute
            offset-y
          >
            <v-card class="pa-2">
              Existencia AdminPaq: {{ existenciaAdminPaq }}
            </v-card>
          </v-menu>

          <h2 class="text-center">Escanear productos con codigo de barras</h2>
          <br />
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Producto</th>
                <th>Cantidad</th>
                <th>Escaneado</th>
                <th>Reiniciar</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(datos, codigo) in pedidoSeleccionado?.productos
                  .lista_productos"
                :key="codigo"
              >
                <td @click="obtenerExistenciaAdminPaq(datos.codigo, $event)">
                  {{ datos.codigo }} - {{ datos.nombre }}<br />
                  <!--Productos secundarios -->
                  <v-list dense class="pa-0">
                    <v-list-item
                      v-for="secundario in datos.tipo === 'paquete'
                        ? datos.componentes
                        : []"
                      :key="secundario.codigo"
                      class="py-1 px-2"
                    >
                      <h4 class="ma-0">
                        • {{ secundario.codigo }} - {{ secundario.nombre }}
                      </h4>
                      <span class="ml-2"
                        >Cantidad: {{ secundario.cantidad }}</span
                      >
                    </v-list-item>
                  </v-list>
                </td>
                <td>
                  <span v-if="datos.tipo === 'paquete'">
                    <!-- Muestra la cantidad de cada componente si es un paquete -->
                    <span
                      v-for="secundario in datos.componentes"
                      :key="secundario.codigo"
                    >
                      {{ secundario.cantidad }}<br />
                    </span>
                  </span>

                  <!-- Muestra la cantidad normal si no es un paquete -->
                  <span v-else>
                    {{ datos.cantidad || 0 }}
                  </span>
                </td>
                <td>
                  <v-icon
                    v-if="
                      datos.tipo === 'paquete' &&
                      datos.componentes?.every(
                        (sec) => sec.cantidad === sec.confirmado,
                      )
                    "
                    color="green"
                  >
                    mdi-check-bold
                  </v-icon>
                  <span v-if="datos.tipo === 'paquete' && datos.componentes">
                    <!-- Mostrar la cantidad confirmada de cada componente dentro del paquete -->
                    <span
                      v-for="secundario in datos.componentes"
                      :key="secundario.codigo"
                    >
                      <span
                        v-if="
                          secundario.confirmado === secundario.cantidad ||
                          secundario.confirmado > 0
                        "
                      >
                        <v-icon color="yellow darken-3">mdi-alert-circle</v-icon
                        >{{ secundario.confirmado }}
                      </span>
                      <span v-else>
                        <v-icon color="red">mdi-close-thick</v-icon>
                        0
                      </span>
                      <br />
                    </span>
                  </span>

                  <span v-else>
                    <!-- Para los productos que no es tipo 'paquete' -->
                    <v-icon
                      v-if="
                        datos.confirmado && datos.confirmado === datos.cantidad
                      "
                      color="green"
                    >
                      mdi-check-bold
                    </v-icon>
                    <v-icon
                      v-if="
                        datos.confirmado && datos.confirmado !== datos.cantidad
                      "
                      color="yellow darken-3"
                      >mdi-alert-circle</v-icon
                    >
                    <span class="text-center" v-if="datos.confirmado">{{
                      datos.confirmado
                    }}</span>

                    <span v-else>
                      <v-icon color="red">mdi-close-thick</v-icon>
                      0
                    </span>
                  </span>
                </td>
                <td>
                  <v-btn
                    icon
                    color="primary"
                    small
                    @click="abrirReiniciarCantidad(datos)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>

            <!-- Este ahora sera el diaglogo para escanear el codigo de barras (aun por implementar)-->
            <v-dialog v-model="dialogProductoEscaneado" max-width="400px">
              <v-card>
                <v-card-title> Producto encontrado </v-card-title>
                <v-card-text>
                  <div>
                    <strong>Código:</strong> {{ productoEscaneadoDialog?.codigo
                    }}<br />
                    <strong>Nombre:</strong>
                    {{ productoEscaneadoDialog?.nombre }}<br />
                    <strong>Cantidad solicitada:</strong>
                    {{ productoEscaneadoDialog?.cantidad }}
                  </div>
                  <v-text-field
                    v-if="productoEscaneadoDialog?.cantidad > 0"
                    v-model.number="productoEscaneadoDialog.cantidadEscaneada"
                    label="¿Cuántos desea escanear?"
                    type="number"
                    min="1"
                    :max="productoEscaneadoDialog?.cantidad"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    @click="confirmarCantidadEscaneada"
                    :disabled="!procesarCodigoPermitido"
                    >Aceptar</v-btn
                  >
                  <v-btn color="grey" text @click="cancelarEscaneoProducto"
                    >Cancelar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogEscaneo" max-width="600px">
              <v-card>
                <v-card-title class="text-center">
                  Escanear código de barras o QR
                </v-card-title>
                <v-card-text class="text-center">
                  <div
                    id="scanner"
                    style="width: 100%; max-height: 300px"
                  ></div>

                  <!-- Instrucciones mejoradas -->
                  <v-row class="mt-3" justify="center">
                    <v-col cols="12" class="text-center">
                      <!-- Estado: Esperando escaneo -->
                      <v-chip
                        v-if="!codigoEscaneado && !escaneoProcesando"
                        color="info"
                        text-color="white"
                        class="mb-2"
                      >
                        <v-icon left small>mdi-camera</v-icon>
                        Apunta al código de barras
                      </v-chip>

                      <!-- Estado: Código detectado pero esperando -->
                      <v-chip
                        v-if="codigoEscaneado && !escaneoProcesando"
                        color="warning"
                        text-color="white"
                        class="mb-2"
                      >
                        <v-icon left small>mdi-timer-sand</v-icon>
                        Mantén estable por 2 segundos...
                      </v-chip>

                      <!-- Estado: Procesando -->
                      <v-chip
                        v-if="escaneoProcesando"
                        color="success"
                        text-color="white"
                        class="mb-2"
                      >
                        <v-progress-circular
                          indeterminate
                          size="16"
                          width="2"
                          color="white"
                          class="mr-2"
                        ></v-progress-circular>
                        Procesando código...
                      </v-chip>
                    </v-col>
                  </v-row>
                  <div v-if="codigoEscaneado">
                    <v-alert
                      :type="escaneoProcesando ? 'success' : 'info'"
                      class="mt-2"
                      :icon="escaneoProcesando ? 'mdi-check' : 'mdi-barcode'"
                    >
                      <strong>Código detectado:</strong> {{ codigoEscaneado }}
                      <br />
                      <small v-if="!escaneoProcesando">
                        Mantén estable, procesando en 2 segundos...
                      </small>
                      <small v-else> Procesando automáticamente... </small>
                    </v-alert>
                  </div>

                  <!-- Consejos para mejor escaneo -->
                  <v-expansion-panels class="mt-3" flat :value="0" readonly>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="text-caption">
                        <v-icon left small>mdi-help-circle</v-icon>
                        Consejos para mejor escaneo
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <ul class="text-left text-caption">
                          <li>
                            Mantén el dispositivo estable durante 2 segundos
                          </li>
                          <li>Asegúrate de tener buena iluminación</li>
                          <li>Coloca el código completo dentro del marco</li>
                          <li>
                            Espera a ver "Procesando código..." antes de mover
                          </li>
                          <li>Si aparece error, prueba entrada manual</li>
                          <li>Una sola alerta aparecerá por escaneo</li>
                        </ul>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="grey" text @click="cerrarEscaneo">
                    <v-icon left>mdi-close</v-icon>
                    Cerrar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogEscaneoManual" max-width="500px">
              <v-card>
                <v-card-title>Confirmar producto manualmente</v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="codigoManualProducto"
                    label="Código del producto"
                    placeholder="Ingrese el código de producto"
                  ></v-text-field>
                  <v-text-field
                    v-model="cantidadManualProducto"
                    label="Cantidad"
                    placeholder="Ingrese la cantidad"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" text @click="enviarProductoManual"
                    >Enviar</v-btn
                  >
                  <v-btn
                    color="primary"
                    text
                    @click="dialogEscaneoManual = false"
                    >Cerrar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogAgregarProductoManual" max-width="400px">
              <v-card>
                <v-card-title>Producto no encontrado</v-card-title>
                <v-card-text>
                  <p>
                    El código de barras
                    <strong>{{ codigoEscaneadoManual }}</strong> no existe en la
                    base de datos.<br />
                    ¿Desea agregarlo manualmente?
                  </p>
                  <v-text-field
                    v-model="codigoProductoManual"
                    label="Código del producto"
                    placeholder="Ingrese el código del producto"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary" text @click="agregarProductoManual"
                    >Agregar</v-btn
                  >
                  <v-btn
                    color="grey"
                    text
                    @click="dialogAgregarProductoManual = false"
                    >Cancelar</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogUnidadesReiniciar" max-width="400px">
              <v-card>
                <v-card-title class="text-subtitle-1 text-justify">
                  ¿Estas seguro de reiniciar a 0 todas las <br />cantidades
                  confirmadas del
                  {{
                    dialogoUnidadesProducto?.codigo.includes("OF")
                      ? "paquete"
                      : "producto"
                  }}
                  <br />de: {{ dialogoUnidadesProducto?.codigo }} -
                  {{ dialogoUnidadesProducto?.nombre }}?
                </v-card-title>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red" text @click="cancelarUnidades"
                    >Si, cancelar</v-btn
                  >
                  <v-btn
                    color="green"
                    text
                    @click="dialogUnidadesReiniciar = false"
                    >No</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <!-- dialog para confirmar comentario generado-->
      <v-dialog v-model="dialogoComentariosGenerados" max-width="600">
        <v-card>
          <v-card-title class="headline"
            >¿Deseas confirmar los comentarios?</v-card-title
          >
          <v-card-text>
            <p>Verifica los comentarios generados:</p>
            <v-textarea
              v-model="textoComentariosGenerados"
              outlined
              rows="5"
              label="Comentarios generados"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="cancelarConfirmacion">Cancelar</v-btn>
            <v-btn color="primary" @click="confirmarDialogo">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>

    <!-- Dialogo para agregar mensajero -->
    <v-dialog v-model="dialogUsuariosGPS" max-width="500px">
      <v-card>
        <v-card-title> Agregar mensajero </v-card-title>
        <v-card-text>
          <v-select
            label="Mensajero"
            v-model="mensajero"
            :items="mensajeros"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            :disabled="!mensajero"
            text
            @click="avanzarRutaEntrega"
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para confirmar el avance de un pedido -->
    <v-dialog v-model="dialogConfirmarAvanzar" max-width="500px">
      <v-card>
        <v-card-title> ¿Avanzar el pedido? </v-card-title>
        <v-card-actions>
          <v-btn color="primary" text @click="avanzarPedidoFacturacion()">
            Avanzar
          </v-btn>
          <v-btn color="primary" text @click="dialogConfirmarAvanzar = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para confirmar el avance de multiples pedidos -->
    <v-dialog
      v-model="dialogConfirmarAvanzarVarios"
      max-width="500px"
      scrollable
    >
      <v-card>
        <v-card-title>
          ¿Avanzar los pedidos?
          <v-spacer></v-spacer>
          <div v-if="selectedPedidos.length > 0">
            <v-btn
              v-if="selectedPedidos[0].estado === 'Preparado'"
              color="primary"
              x-small
              @click="agregarMensajeroVarios"
            >
              Agregar mensajero
            </v-btn>
          </div>
        </v-card-title>
        <div v-if="selectedPedidos.length > 0">
          <v-subheader v-if="selectedPedidos[0].estado === 'Facturación'"
            >Asegurate que todos los pedidos cuentan con una factura asociada
          </v-subheader>
        </div>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <!-- <v-list>
              <v-list-item v-for="item in selectedPedidos" :key="item.id">
                <v-list-item-content>
                  <v-list-item-title>{{
                    item.id + " - " + item.cliente
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list> -->
          <v-data-table
            :headers="headersAvanzarPedidos"
            :items="selectedPedidos"
            hide-default-header
            hide-default-footer
            :items-per-page="-1"
            dense
          ></v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="avanzarVariosPedidos">
            Avanzar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="dialogConfirmarAvanzarVarios = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para mostrar el progreso de multiples pedidos -->
    <v-dialog
      v-model="dialogProgresoAvanzarVarios"
      max-width="500px"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>Avanzando pedidos</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <v-data-table
            :headers="headersAvanzandoPedidos"
            :items="pedidosConEstadoSolicitud"
            hide-default-header
            hide-default-footer
            :items-per-page="-1"
            dense
          >
            <!-- Columna del estado de solicitud -->
            <template v-slot:[`item.solicitud`]="{ item }">
              <v-chip
                v-if="item.solicitud === 'En espera...'"
                color="primary"
                small
              >
                {{ item.solicitud }}
              </v-chip>
              <v-progress-circular
                v-if="item.solicitud === 'Procesando...'"
                :size="20"
                :width="3"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <v-icon
                v-if="item.solicitud === 'Completado'"
                color="green"
                size="20"
                >mdi-check-circle</v-icon
              >
              <v-icon
                v-if="item.solicitud === 'No completado'"
                color="red"
                size="20"
                >mdi-close-circle</v-icon
              >
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            :disabled="AvanzandoPedidosBtn"
            text
            @click="dialogProgresoAvanzarVarios = false"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para agregar mensajero individualmente avanzando varios pedidos-->
    <v-dialog v-model="dialogUsuariosGPSVarios" max-width="500px" scrollable>
      <v-card>
        <v-card-title> Agregar mensajero a los pedidos</v-card-title>
        <v-card-text>
          <div v-for="pedido in pedidosConEstadoSolicitud" :key="pedido.id">
            <p>{{ pedido.id }} - {{ pedido.cliente }}</p>
            <v-select
              v-model="pedido.nuevoMensajero"
              :items="mensajeros"
              label="Mensajero"
            ></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="avanzarRutaEntregaVarios"
            :disabled="!todosMensajerosSeleccionados"
            >Agregar</v-btn
          >
          <v-btn color="primary" text @click="dialogUsuariosGPSVarios = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para agregar el mismo mensajero a varios pedidos preparados-->
    <v-dialog v-model="dialogAgregarMensajeroAll" max-width="500px" scrollable>
      <v-card>
        <v-card-title> Agregar mensajero a todos los pedidos</v-card-title>
        <v-card-text>
          <v-subheader>
            Este mensajero se asignará a todos los pedidos seleccionados
          </v-subheader>
          <v-select
            v-model="mensajeroParaVariosPreparados"
            :items="mensajeros"
            label="Mensajero"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="avanzarVariosPreparados"
            :disabled="!mensajeroParaVariosPreparados"
            >Agregar y avanzar</v-btn
          >
          <v-btn
            color="primary"
            text
            @click="dialogAgregarMensajeroAll = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AccionesPedido from "@/components/AccionesPedido.vue";
import axios from "axios";
import { format, subMinutes, subHours } from "date-fns";

export default {
  props: ["items", "usuarios", "clientes"],
  data() {
    return {
      dialogoComentariosGenerados: false,
      textoComentariosGenerados: "",
      resolverConfirmacion: null, //una promesa que se resuelve cuando se confirma el metodo y continuar
      dialogCantidadGlobal: false,
      productosSeleccionadoParaDialog: null,
      agregarComentario: false,
      nuevoComentario: "",
      abrirDetallesPreparacion: false,
      pedidoSeleccionado: null,
      comentariosDelPedido: [],
      confirmarEnvio: false,
      formatoSeleccionado: null,
      selectedTab: 0,
      pedidoAvanzar: null, //almacena el pedido que se va a avanzar en el dialog de dialogConfirmarAvanzar
      selectedPedidos: [], //almacena los pedidos seleccionados para avanzarlos juntos
      pedidosConEstadoSolicitud: [], //almacena los pedidos con estado de solicitud para mostrar su progreso
      search: "",
      filtroEstado: "",
      itemsActuales: [],
      headers: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Cliente",
          value: "cliente",
        },
        /*{
          text: "Total",
          value: "total",
        },
        {
          text: "Lista de productos",
          value: "lista_productos",
          sortable: false,
        },
        {
          text: "Pago",
          value: "pago",
        },
        {
          text: "Vendedor",
          value: "vendedor",
        },*/
        {
          text: "Zona",
          value: "localizacion.zona",
        },
        {
          text: "Antigüedad",
          value: "fecha_creacion",
        },
        /*
        {
          text: "Discrepancias",
          value: "discrepancias",
        },
        {
          text: "Facturas",
          value: "facturas",
        },*/
        {
          text: "Estado",
          value: "estado",
          filter: (value) => {
            if (!this.filtroEstado);

            return value === "Confirmación";
          },
          class: "d-none",
          cellClass: "d-none",
        },

        {
          text: "Necesita revisión",
          value: "necesitaRevision",
          sortable: false,
          class: "d-none",
          cellClass: "d-none",
        },
        {
          text: "Avanzar a:",
          value: "avanzar_a",
          sortable: false,
          class: "d-none",
          cellClass: "d-none",
        },
      ],
      headersAvanzarPedidos: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Cliente",
          value: "cliente",
        },
      ],
      headersAvanzandoPedidos: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Cliente",
          value: "cliente",
        },
        {
          text: "Solicitud",
          value: "solicitud",
          align: "center",
        },
      ],
      ordenSucursales: [
        "Mexicali",
        "Tijuana",
        "Ensenada",
        "LaPaz",
        "Obregon",
        "Hermosillo",
      ],
      ordenEstados: [
        {
          text: "Pedido creado",
          value: "pedido_creado",
        },
        {
          text: "Confirmación",
          value: "confirmacion",
        },
        {
          text: "Facturación",
          value: "facturacion",
        },
        {
          text: "Preparación en almacén",
          value: "preparacion_en_almacen",
        },
        {
          text: "Preparado",
          value: "preparado",
        },
        {
          text: "En ruta de entrega",
          value: "en_ruta_de_entrega",
        },
        {
          text: "Entregado",
          value: "entregado",
        },
      ],
      listaEstados: [
        {
          text: "Sin filtro",
          value: "",
        },
        {
          text: "Pedido creado",
        },
        {
          text: "Revisión de crédito",
        },
        {
          text: "Confirmación",
        },
        {
          text: "Facturación",
        },
        {
          text: "Preparación en almacén",
        },
        {
          text: "Preparado",
        },
        {
          text: "En ruta de entrega",
        },
      ],
      estadosPedidos: [
        "Pedido creado",
        "Revisión de crédito",
        "Confirmación",
        "Facturación",
        "Preparación en almacén",
        "Preparado",
        "En ruta de entrega",
      ],
      RutaFormatos: [
        {
          text: "ID Pedido",
          value: "pedidosPreparadosIDs",
          sortable: false,
        },
        {
          text: "Cliente",
          value: "clientes",
          sortable: false,
        },
        {
          text: "Mensajero",
          value: "mensajero",
          sortable: false,
        },
      ],
      estadosSelected: ["Preparado"],
      itemsSucursalesDisponibles: [],
      itemsFiltrados: [],
      itemsPedidos: this.items,
      dialogUsuariosGPS: false,
      dialogConfirmarAvanzar: false,
      dialogConfirmarAvanzarVarios: false,
      dialogProgresoAvanzarVarios: false,
      dialogUsuariosGPSVarios: false,
      dialogAgregarMensajeroAll: false,
      dialogPedidosSinLocalizacion: false,
      AvanzandoPedidosBtn: true,

      pedidoEnRuta: null,
      mensajero: "",
      mensajeroParaVariosPreparados: "",
      mensajeros: [],
      mensajerosImpresion: [],
      mensajeroSelected: null,
      arrayComentariosNuevos: [],
      pedidosConLocalizacion: [],
      pedidosSinLocalizacion: [],
      dialogComentarios: false,
      dialogPedidos: false,

      dialogoFormatos: false,
      formatosVisibles: 5,
      mostrarTodos: false,

      sucursalesDirecciones: {},

      dialogEscaneo: false,
      codigoEscaneado: "",
      scanner: null,
      dialogProductoEscaneado: false,
      productoEscaneadoDialog: null,
      dialogAgregarProductoManual: false,
      codigoEscaneadoManual: "",
      codigoProductoManual: "",
      dialogUnidadesReiniciar: false,
      dialogoUnidadesProducto: null,
      dialogEscaneoManual: false,
      codigoManualProducto: "",
      cantidadManualProducto: "",

      // Variables para mejorar el escaneo
      ultimoCodigoEscaneado: "",
      timeoutEscaneo: null,
      escaneoProcesando: false, // Bandera para evitar múltiples procesamientos
      mensajeMostrandose: false, // Evitar múltiples alertas
      escaneadorActivo: false, // Control de estado del escáner
      procesarCodigoPermitido: true, // Bandera para permitir procesamiento

      tooltipVisible: false,
      existenciaAdminPaq: null,
      x: 0,
      y: 0,
    };
  },
  methods: {
    // Función para detectar si el texto escaneado es un código de producto directo
    esCodigoProductoDirecto(texto) {
      //si el texto recibido es un texto con coma, tomar el primer valor sera el codigo de producto
      if (texto.includes(",")) {
        texto = texto.split(",")[0];
      }

      if (!texto) return false;

      // Un código de producto típicamente tiene un formato específico
      // Ejemplo: BAYEP279, PRODB123, etc.
      // Normalmente son alfanuméricos, longitud de 6-12 caracteres, sin espacios
      const regexCodigoProducto = /^[A-Z0-9]{4,12}$/i;

      // También verificar que no sea un código de barras típico (números largos)
      const esCodigoBarras = /^\d{8,}$/.test(texto);

      return regexCodigoProducto.test(texto) && !esCodigoBarras;
    },
    // Función para buscar producto directamente en la lista del pedido
    async buscarProductoDirectoEnPedido(codigoProducto) {
      let productoLista = null;

      if (this.pedidoSeleccionado?.productos?.lista_productos) {
        for (let producto of this.pedidoSeleccionado.productos
          .lista_productos) {
          // Buscar en componentes de paquete
          if (
            producto.tipo === "paquete" &&
            Array.isArray(producto.componentes)
          ) {
            productoLista = producto.componentes.find(
              (p) => p.codigo.toUpperCase() === codigoProducto.toUpperCase(),
            );
          }
          // Buscar directamente
          if (!productoLista) {
            productoLista =
              this.pedidoSeleccionado.productos.lista_productos.find(
                (p) => p.codigo.toUpperCase() === codigoProducto.toUpperCase(),
              );
          }

          if (productoLista) break;
        }
      }

      return productoLista;
    },

    abrirEscaneoProductosManual() {
      this.dialogEscaneoManual = true;
    },

    async enviarProductoManual() {
      if (!this.codigoManualProducto.trim()) {
        alert("Debes ingresar el código del producto.");
        return;
      }

      if (!this.cantidadManualProducto || this.cantidadManualProducto <= 0) {
        alert("Debes ingresar una cantidad válida.");
        return;
      }

      try {
        await axios.post(
          `/pedidos/escanear_producto?id_pedido=${this.pedidoSeleccionado.id}&cantidad_escaneada=${this.cantidadManualProducto}&codigo_producto=${this.codigoManualProducto}`,
        );

        alert(
          `Has confirmado: ${this.cantidadManualProducto} unidades del producto: ${this.codigoManualProducto}`,
        );

        await this.getPedidosById(this.pedidoSeleccionado.id);
        this.dialogEscaneoManual = false;

        // Limpiar campos
        this.codigoManualProducto = "";
        this.cantidadManualProducto = "";
      } catch (error) {
        if (error.response && error.response.status === 400) {
          alert(
            "Error: El producto ya fue escaneado o no existe en el pedido.",
          );
        } else {
          alert(
            "Error al enviar el producto. Verifica tu conexión e intenta nuevamente.",
          );
        }
      }
    },

    async abrirEscaneoProductos() {
      try {
        // Reset completo de todas las variables de control
        this.resetearEstadoEscaner();

        this.dialogEscaneo = true;
        this.escaneadorActivo = true;
        this.procesarCodigoPermitido = true;

        this.$nextTick(() => {
          this.iniciarEscaner();
        });
      } catch (e) {
        this.mostrarAlertaSegura(
          "No se pudo acceder a la cámara. Asegúrate de que el navegador tenga permisos para usarla.",
        );
        this.dialogEscaneo = false;
        this.escaneadorActivo = false;
      }
    },

    resetearEstadoEscaner() {
      // Limpiar todos los timeouts
      if (this.timeoutEscaneo) {
        clearTimeout(this.timeoutEscaneo);
        this.timeoutEscaneo = null;
      }

      // Reset de todas las variables de estado
      this.codigoEscaneado = "";
      this.ultimoCodigoEscaneado = "";
      this.escaneoProcesando = false;
      this.mensajeMostrandose = false;
      this.escaneadorActivo = false;
      this.procesarCodigoPermitido = true;
    },

    cerrarEscaneo() {
      // IMPORTANTE: Deshabilitar inmediatamente el procesamiento
      this.procesarCodigoPermitido = false;
      this.escaneadorActivo = false;

      // Cerrar diálogo
      this.dialogEscaneo = false;

      // Limpiar timeouts pendientes
      if (this.timeoutEscaneo) {
        clearTimeout(this.timeoutEscaneo);
        this.timeoutEscaneo = null;
      }

      // Detener scanner de forma segura
      if (this.scanner) {
        try {
          this.scanner
            .stop()
            .then(() => {
              try {
                this.scanner.clear();
              } catch (e) {
                console.log("Error al limpiar scanner:", e);
              }
              this.scanner = null;
            })
            .catch((e) => {
              console.log("Error al detener scanner:", e);
              // Forzar limpieza
              try {
                this.scanner.clear();
              } catch (clearError) {
                console.log("Error al forzar limpieza:", clearError);
              }
              this.scanner = null;
            });
        } catch (e) {
          console.log("Error general del scanner:", e);
          this.scanner = null;
        }
      }

      // Reset completo después de un breve delay
      setTimeout(() => {
        this.resetearEstadoEscaner();
      }, 500);
    },

    iniciarEscaner() {
      import("html5-qrcode").then(({ Html5Qrcode }) => {
        if (this.scanner) {
          try {
            this.scanner
              .stop()
              .then(() => {
                this.scanner.clear();
              })
              .catch(() => {});
          } catch (e) {
            // Ignora el error si ya estaba limpio
          }
          this.scanner = null;
        }

        this.scanner = new Html5Qrcode("scanner");
        this.scanner.start(
          { facingMode: "environment" },
          { fps: 6, qrbox: { width: 350, height: 450 }, aspectRatio: 1 }, // FPS más bajo para mayor estabilidad
          async (decodedText) => {
            // VERIFICACIONES DE SEGURIDAD PRINCIPALES
            if (!this.escaneadorActivo || !this.procesarCodigoPermitido) {
              return; // Escáner desactivado, no procesar
            }

            if (this.escaneoProcesando || this.mensajeMostrandose) {
              return; // Ya procesando o mostrando mensaje
            }

            // Evitar el mismo código consecutivo
            if (decodedText === this.ultimoCodigoEscaneado) {
              return;
            }

            // Limpiar timeout previo
            if (this.timeoutEscaneo) {
              clearTimeout(this.timeoutEscaneo);
            }

            // Actualizar estado
            this.ultimoCodigoEscaneado = decodedText;
            this.codigoEscaneado = decodedText;
            this.escaneoProcesando = true;

            // Timeout para procesar - con verificaciones adicionales
            this.timeoutEscaneo = setTimeout(async () => {
              // Verificar nuevamente si aún podemos procesar
              if (
                !this.escaneadorActivo ||
                !this.procesarCodigoPermitido ||
                this.mensajeMostrandose
              ) {
                this.escaneoProcesando = false;
                return;
              }

              try {
                // Reproducir sonido
                this.reproducirSonidoSeguro();

                let productoApi = null;
                let productoLista = null;

                // CASO 1: Verificar si es un código de producto directo (ej: BAYEP279)
                if (this.esCodigoProductoDirecto(decodedText)) {
                  //separar el codigo de barrras recibido por coma
                  const parts = decodedText.split(",");
                  const codigoProductoDirecto = parts[0]; // Primer parte es el código del producto
                  //const localizacion = parts[1]; // Segunda parte es la localización (si existe)

                  productoLista = await this.buscarProductoDirectoEnPedido(
                    codigoProductoDirecto,
                  );

                  /*
                  // Buscar directamente en la lista del pedido por código
                  productoLista = await this.buscarProductoDirectoEnPedido(
                    decodedText
                  );*/

                  if (productoLista) {
                    // Crear objeto de producto simulado para mantener compatibilidad
                    productoApi = {
                      codigo: productoLista.codigo,
                      codigo_de_barras: decodedText, // Usar el QR como código de barras
                    };
                  }
                }

                // CASO 2: Si no es código directo o no se encontró, buscar por código de barras en API
                if (!productoLista) {
                  const response = await axios.get(
                    `/productos/get_by_codigo_de_barras?codigo_de_barras=${decodedText}`,
                    { timeout: 6000 },
                  );
                  productoApi = response.data;

                  // Verificar una vez más antes de continuar
                  if (!this.escaneadorActivo || !this.procesarCodigoPermitido) {
                    return;
                  }

                  // Buscar en lista de productos del pedido
                  if (this.pedidoSeleccionado?.productos?.lista_productos) {
                    for (let producto of this.pedidoSeleccionado.productos
                      .lista_productos) {
                      // Buscar en componentes de paquete
                      if (
                        producto.tipo === "paquete" &&
                        Array.isArray(producto.componentes)
                      ) {
                        productoLista = producto.componentes.find(
                          (p) => p.codigo === productoApi.codigo,
                        );
                      }
                      // Buscar directamente
                      if (!productoLista) {
                        productoLista =
                          this.pedidoSeleccionado.productos.lista_productos.find(
                            (p) => p.codigo === productoApi.codigo,
                          );
                      }

                      if (productoLista) break;
                    }
                  }
                }

                // Verificar estado una última vez antes de mostrar resultado
                if (!this.escaneadorActivo || !this.procesarCodigoPermitido) {
                  return;
                }

                if (productoLista) {
                  // Producto encontrado - abrir diálogo
                  this.productoEscaneadoDialog = {
                    codigo: productoApi.codigo,
                    codigo_de_barras: productoApi.codigo_de_barras,
                    nombre: productoLista.nombre,
                    cantidad: productoLista.cantidad,
                    cantidadEscaneada: 1,
                    esCodigoDirecto: this.esCodigoProductoDirecto(decodedText), // Marcar si es código directo
                  };
                  this.dialogProductoEscaneado = true;
                  this.cerrarEscaneo(); // Cerrar escáner al encontrar producto
                } else {
                  // Producto no en pedido - mostrar mensaje apropiado
                  if (productoApi && productoApi.codigo) {
                    await this.mostrarMensajeUnicoYCerrar(
                      `El producto ${productoApi.codigo} no está en este pedido.`,
                    );
                  } else {
                    // Caso cuando es código directo pero no existe en el pedido
                    await this.mostrarMensajeUnicoYCerrar(
                      `El código de producto ${decodedText} no está en este pedido.`,
                    );
                  }
                }
              } catch (error) {
                // Verificar estado antes de manejar error
                if (!this.escaneadorActivo || !this.procesarCodigoPermitido) {
                  return;
                }

                if (error.response?.status === 404) {
                  // Código de barras no encontrado en API
                  // Solo abrir diálogo si NO es un código de producto directo
                  if (!this.esCodigoProductoDirecto(decodedText)) {
                    if (!this.mensajeMostrandose) {
                      this.codigoEscaneadoManual = decodedText;
                      this.codigoProductoManual = "";
                      this.dialogAgregarProductoManual = true;
                      this.cerrarEscaneo();
                    }
                  } else {
                    // Es código directo pero no está en el pedido
                    await this.mostrarMensajeUnicoYCerrar(
                      `El código de producto ${decodedText} no está en este pedido.`,
                    );
                  }
                } else {
                  // Error de conexión
                  await this.mostrarMensajeUnicoYCerrar(
                    "Error de conexión. Verifica tu señal de internet.",
                  );
                }
              } finally {
                this.escaneoProcesando = false;
              }
            }, 1800); // Reducido a 1.8 segundos
          },
          (errorMessage) => {
            console.log(errorMessage);
            // Manejo silencioso de errores de escaneo
            // No mostrar alertas por errores normales de lectura
          },
        );
      });
    },

    async confirmarCantidadEscaneada() {
      const prod = this.productoEscaneadoDialog;
      if (
        !prod ||
        prod.cantidadEscaneada == null ||
        prod.cantidadEscaneada <= 0
      ) {
        this.mostrarAlertaSegura("Ingrese una cantidad válida.");
        return;
      }

      // Deshabilitar procesamiento adicional
      this.procesarCodigoPermitido = false;

      try {
        // Intentar la solicitud con timeout y reintentos
        await this.enviarEscaneoConReintentos(prod);

        this.mostrarAlertaSegura(
          "Producto marcado como escaneado correctamente.",
        );
        this.dialogProductoEscaneado = false;

        // Actualiza el pedido para refrescar la tabla
        await this.getPedidosById(this.pedidoSeleccionado.id);
      } catch (error) {
        console.log("Error al marcar como escaneado:", error);
        if (error.response && error.response.status === 400) {
          this.mostrarAlertaSegura(
            "No puedes escanear más de una vez el mismo producto.",
          );
        } else if (
          error.code === "ECONNABORTED" ||
          error.message.includes("timeout")
        ) {
          this.mostrarAlertaSegura(
            "Tiempo de espera agotado. Verifica tu conexión e intenta nuevamente.",
          );
        } else if (!navigator.onLine) {
          this.mostrarAlertaSegura(
            "Sin conexión a internet. Verifica tu señal e intenta nuevamente.",
          );
        } else {
          this.mostrarAlertaSegura(
            "Error al procesar el escaneo. Intenta nuevamente.",
          );
        }
      } finally {
        // Reset completo del estado
        this.resetearEstadoEscaner();
      }
    },

    async enviarEscaneoConReintentos(prod, intentos = 3) {
      for (let i = 0; i < intentos; i++) {
        try {
          // Configurar timeout más largo para conexiones lentas
          let endpoint;

          // Si es código directo (producto escaneado por QR de producto, no código de barras)
          if (prod.esCodigoDirecto) {
            // Usar endpoint específico para códigos de producto
            endpoint = `/pedidos/escanear_producto?codigo_producto=${this.productoEscaneadoDialog.codigo}&id_pedido=${this.pedidoSeleccionado.id}&cantidad_escaneada=${prod.cantidadEscaneada}`;
          } else {
            // Usar endpoint tradicional para códigos de barras
            endpoint = `/pedidos/escanear_producto?codigo_de_barras=${this.productoEscaneadoDialog.codigo_de_barras}&id_pedido=${this.pedidoSeleccionado.id}&cantidad_escaneada=${prod.cantidadEscaneada}`;
          }

          await axios.post(endpoint);
          return; // Éxito, salir del bucle
        } catch (error) {
          if (i === intentos - 1) {
            // Último intento fallido
            throw error;
          }

          // Esperar antes del siguiente intento (backoff exponencial)
          await new Promise((resolve) =>
            setTimeout(resolve, Math.pow(2, i) * 1000),
          );
        }
      }
    },
    reproducirSonido() {
      const audio = new Audio(require("@/assets/scanner-check.mp3"));
      audio.play();
    },

    reproducirSonidoSeguro() {
      try {
        const audio = new Audio(require("@/assets/scanner-check.mp3"));
        audio.volume = 0.5; // Volumen más bajo

        // Configurar el audio para que no se trabe
        audio.preload = "auto";

        // Reproducir con manejo de errores
        const playPromise = audio.play();

        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            // Error silencioso - no mostrar alerta al usuario
            console.log("Error al reproducir sonido:", error);
          });
        }
      } catch (error) {
        // Error silencioso
        console.log("Error al crear audio:", error);
      }
    },

    mostrarMensajeSeguro(mensaje) {
      // Mostrar mensaje de forma que no interfiera con el escaneo
      this.$nextTick(() => {
        alert(mensaje);
      });
    },

    async mostrarMensajeUnico(mensaje) {
      // Evitar mostrar múltiples mensajes al mismo tiempo
      if (this.mensajeMostrandose) {
        return;
      }

      this.mensajeMostrandose = true;

      try {
        // Usar una promesa para controlar cuando se cierra la alerta
        await new Promise((resolve) => {
          this.$nextTick(() => {
            alert(mensaje);
            resolve();
          });
        });
      } finally {
        // Esperar un poco antes de permitir otro mensaje
        setTimeout(() => {
          this.mensajeMostrandose = false;
        }, 1000);
      }
    },

    async mostrarMensajeUnicoYCerrar(mensaje) {
      // Esta función muestra el mensaje Y cierra el escáner de inmediato
      if (this.mensajeMostrandose) {
        return;
      }

      // Cerrar escáner ANTES de mostrar mensaje para evitar callbacks adicionales
      this.cerrarEscaneo();

      this.mensajeMostrandose = true;

      try {
        await new Promise((resolve) => {
          // Pequeño delay para asegurar que el escáner se cerró
          setTimeout(() => {
            alert(mensaje);
            resolve();
          }, 200);
        });
      } finally {
        setTimeout(() => {
          this.mensajeMostrandose = false;
        }, 800);
      }
    },

    mostrarAlertaSegura(mensaje) {
      // Para mensajes que no requieren control de duplicados
      this.$nextTick(() => {
        alert(mensaje);
      });
    },

    cancelarEscaneoProducto() {
      // Cerrar diálogo y resetear estado completo
      this.dialogProductoEscaneado = false;
      this.productoEscaneadoDialog = null;
      this.resetearEstadoEscaner();
    },

    async agregarProductoManual() {
      if (!this.codigoProductoManual) {
        alert("Debe ingresar el código del producto.");
        return;
      }
      try {
        await axios.post(
          `/productos/set_codigo_de_barras?codigo_de_barras=${this.codigoEscaneadoManual}&codigo_producto=${this.codigoProductoManual}`,
        );
        alert("Producto agregado correctamente.");
        this.dialogAgregarProductoManual = false;
        this.codigoEscaneadoManual = "";
        this.codigoProductoManual = "";
        // Opcional: refrescar la lista de productos
      } catch (error) {
        alert("Error al agregar el producto.");
      }
    },

    abrirReiniciarCantidad(producto) {
      if (producto.confirmado === 0) {
        return alert("No hay unidades confirmadas para reiniciar.");
      }
      this.dialogoUnidadesProducto = producto;
      this.dialogUnidadesReiniciar = true;
    },

    cancelarUnidades() {
      const productos = this.dialogoUnidadesProducto;

      try {
        axios.post(
          `/pedidos/cancelar_escaneo?id_pedido=${this.pedidoSeleccionado.id}&codigo_producto=${productos.codigo}`,
        );
        alert("Cantidad confirmada reiniciada correctamente");
        this.getPedidosById(this.pedidoSeleccionado.id);
        this.dialogUnidadesReiniciar = false;
      } catch (error) {
        console.error("Error al habilitar al cancelar la cantidad:", error);
      }
    },

    async getPedidosById(id) {
      try {
        const response = await axios.get(`/pedidos/get_by_id?id_pedido=${id}`);
        this.pedidoSeleccionado = response.data;
        console.log("Pedido obtenido:", this.pedidoSeleccionado);
        /*await this.inicializarProductos();
        await this.obtenerComentariosDelPedido(id);*/
      } catch (error) {
        console.error("Error al obtener el pedido por ID:", error);
      }
    },

    confirmarCantidad() {
      const producto = this.productosSeleccionadoParaDialog;
      if (
        !producto ||
        (producto.cantidadReal !== null && producto.cantidadReal < 0)
      ) {
        alert("Ingrese una cantidad válida");
        return;
      }
      if (producto.cantidadReal !== producto.cantidad) {
        alert(
          `La cantidad ingresada no coincide con la cantidad del producto.`,
        );
        return;
      }
      // Si la cantidad es correcta, abre el escaneo
      this.dialogCantidadGlobal = false;
      this.productosSeleccionadoParaDialog = null;
      this.dialogEscaneo = true;
      this.$nextTick(() => {
        this.iniciarEscaner();
      });
    },

    cancelarDialogoCantidad() {
      this.dialogCantidadGlobal = false;
      this.productosSeleccionadoParaDialog = null;
    },

    async inicializarProductos() {
      if (this.pedidoSeleccionado?.productos.lista_productos) {
        this.pedidoSeleccionado.productos.lista_productos.forEach(
          (producto) => {
            if (producto.estado === undefined)
              this.$set(producto, "estado", producto.estado || null);
            if (producto.cantidadReal === undefined)
              this.$set(producto, "cantidadReal", null);
            if (producto.bloqueado === undefined)
              this.$set(producto, "bloqueado", false);
            if (producto.dialogCantidad === undefined)
              this.$set(producto, "dialogCantidad", false);
          },
        );
      }
    },

    abrirVistaPreparacion(item) {
      this.pedidoSeleccionado = item;
      this.abrirDetallesPreparacion = true;
    },

    cerrarDialogDetallesConfirmacion() {
      this.abrirDetallesPreparacion = false;
      this.pedidoSeleccionado = null;
    },

    async obtenerExistenciaAdminPaq(codigo, event) {
      this.x = event.clientX;
      this.y = event.clientY;
      try {
        this.tooltipVisible = false; // Ocultar tooltip mientras se carga la información
        const response = await axios.get(
          `/productos/consulta?codigo=${codigo}&sucursal=${this.pedidoSeleccionado.sucursal}`,
        );

        this.existenciaAdminPaq = response.data.existencia;
        this.tooltipVisible = true; // Mostrar tooltip con la información obtenida
      } catch (error) {
        console.error("Error al obtener existencia de AdminPaq:", error);
      }
    },

    async generarComentariosProductos() {
      const productos = this.pedidoSeleccionado.productos.lista_productos;
      const secundarios = productos.flatMap(
        (producto) => producto.componentes || [],
      );

      const comentarios = [];

      productos.forEach((prod) => {
        if (prod.confirmado === prod.cantidad || prod.codigo.includes("OF")) {
          // Se validó como correcto, no requiere comentario
          return;
        }

        if (prod.confirmado < prod.cantidad && !prod.codigo.includes("OF")) {
          comentarios.push(
            `El producto ${prod.codigo} (${prod.nombre}) tenía solicitados: ${prod.cantidad}, pero solo hay: ${prod.confirmado} en stock.`,
          );
        }
      });

      secundarios.forEach((sec) => {
        if (sec.confirmado === sec.cantidad) {
          // Se validó como correcto, no requiere comentario
          return;
        }

        if (sec.confirmado < sec.cantidad) {
          comentarios.push(
            `El producto ${sec.codigo} (${sec.nombre}) tiene solicitados: ${sec.cantidad}, pero solo hay: ${sec.confirmado} en stock.`,
          );
        }
      });

      if (comentarios.length === 0) {
        alert("No hay comentarios que generar.");
        return;
      }

      this.textoComentariosGenerados = comentarios.join("\n");
      const confirmado = await this.mostrarDialogComentariosConfirmacion();
      if (!confirmado) {
        return;
      }

      try {
        await axios.post("/varios/crear_comentario", null, {
          params: {
            id_objeto: this.pedidoSeleccionado.id,
            tipo_objeto: "pedido",
            comentario: this.textoComentariosGenerados,
          },
        });

        alert("Comentarios creados correctamente.");
        this.obtenerComentariosDelPedido(this.pedidoSeleccionado.id);
      } catch (error) {
        console.error("Error al crear comentarios:", error);
        alert("Hubo un problema al crear comentarios.");
      }
    },

    async obtenerComentariosDelPedido(idPedido) {
      try {
        const response = await axios.get(
          `/varios/get_comentarios?id_objeto=${idPedido}&tipo_objeto=pedido`,
        );
        this.comentariosDelPedido = response.data.slice().reverse();
      } catch (error) {
        console.error("Error al obtener los comentarios del pedido:", error);
        this.comentariosDelPedido = [];
      }
    },

    async crearComentario() {
      try {
        await axios.post(
          `/varios/crear_comentario?id_objeto=${this.pedidoSeleccionado.id}&tipo_objeto=pedido&comentario=${this.nuevoComentario}`,
        );
        alert("Comentario creado con éxito");
        this.nuevoComentario = ""; // Limpiar el campo de texto después de enviar el comentario
        this.agregarComentario = false; // Cerrar el diálogo de agregar comentario
        this.obtenerComentariosDelPedido(this.pedidoSeleccionado.id);
      } catch (error) {
        console.error("Error al crear el comentario:", error);
      }
    },

    validarProductos() {
      const productosNoMarcados =
        this.pedidoSeleccionado.productos.lista_productos.filter(
          (producto) => !producto.checked,
        );

      if (productosNoMarcados.length === 0) {
        alert("Todos los productos han sido validados");
        return;
      }

      const nombresProductos = productosNoMarcados
        .map((producto) => `${producto.codigo} - ${producto.nombre}`)
        .join(", ");

      const comentario = `No hay stock de los siguientes productos: ${nombresProductos}`;
      this.crearComentarioAutomatico(comentario);
    },

    async crearComentarioAutomatico(comentario) {
      try {
        await axios.post(
          `/varios/crear_comentario?id_objeto=${this.pedidoSeleccionado.id}&tipo_objeto=pedido&comentario=${comentario}`,
        );
        alert(
          "Validación de productos creada con éxito y comentario creado con éxito.",
        );
        this.obtenerComentariosDelPedido(this.pedidoSeleccionado.id);
      } catch (error) {
        console.error("Error al crear el comentario:", error);
      }
    },

    //funcion que muestra el dialog y espera confirmacion
    mostrarDialogComentariosConfirmacion() {
      this.dialogoComentariosGenerados = true;

      return new Promise((resolve) => {
        this.resolverConfirmacion = resolve;
      });
    },

    confirmarDialogo() {
      this.dialogoComentariosGenerados = false;
      if (this.resolverConfirmacion) {
        this.resolverConfirmacion(true);
        this.resolverConfirmacion = null;
      }
    },

    cancelarConfirmacion() {
      this.dialogoComentariosGenerados = false;
      if (this.resolverConfirmacion) {
        this.resolverConfirmacion(false);
        this.resolverConfirmacion = null;
      }
    },

    getVendedor(vendedorId) {
      const vendedorEncontrado = this.usuarios.find(
        (usuario) => usuario.id === vendedorId,
      );
      if (vendedorEncontrado) {
        return vendedorEncontrado.nombre + " ";
      }
      return "";
    },

    abrirDialogoConfirmacion(formato) {
      this.formatoSeleccionado = formato;
      this.confirmarEnvio = true;
    },

    cerrarDialogoConfirmacion() {
      this.confirmarEnvio = false;
      this.formatoSeleccionado = null;
    },

    confirmarActualizarPedidos() {
      if (this.formatoSeleccionado) {
        this.actualizarPedidosARuta(this.formatoSeleccionado);
      }
      this.cerrarDialogoConfirmacion();
    },

    obtenerSucursalActual() {
      const nombreSucursal = this.ordenSucursales[this.selectedTab];
      return this.sucursalesDirecciones[nombreSucursal] || {};
    },

    calcularTotalDePedidos() {
      //calcular el total de los pedidos de cada estado

      return this.pedidos.reduce((total, pedido) => total + pedido.total, 0);
    },

    mostrarMasFormatos() {
      this.formatosVisibles += 5;
      this.mostrarTodos = true;
    },

    ocultarFormatos() {
      this.formatosVisibles = 5;
      this.mostrarTodos = false;
    },

    obtenerMensajeroConGps() {
      const sucursalActiva = this.ordenSucursales[this.selectedTab];

      this.mensajerosImpresion = this.usuarios
        .filter(
          (usuario) =>
            usuario.gps !== null && usuario.sucursal === sucursalActiva,
        )
        .map((mensajero) => ({
          text: mensajero.nombre,
          value: mensajero.id,
        }));
    },

    selectPedido(event, rowInfo) {
      // Comprobamos si el objeto ya existe en el array
      const index = this.selectedPedidos.findIndex(
        (pedido) => pedido.id === rowInfo.item.id,
      );

      if (index !== -1) {
        // Si el objeto ya existe, lo eliminamos del array
        this.selectedPedidos.splice(index, 1);
      } else {
        // Si no existe, lo agregamos al array
        this.selectedPedidos.push(rowInfo.item);
      }

      console.log(this.selectedPedidos);
    },
    agregarMensajeroVarios() {
      const mensajerosArray = this.usuarios.filter(
        (usuario) =>
          usuario.sucursal === this.selectedPedidos[0].sucursal &&
          usuario.gps !== null,
      );
      console.log(mensajerosArray);

      this.mensajeros = mensajerosArray.map((mensajero) => ({
        text: mensajero.nombre,
        value: mensajero.id,
      }));

      this.dialogAgregarMensajeroAll = true;
    },
    async avanzarVariosPreparados() {
      console.log(this.mensajeroParaVariosPreparados);
      console.log("se avanzan los pedidos");
      // se le asigna el estado 'en espera...' a todos los pedidos. Ese estado se ira modificando comforme se avancen los pedidos
      const pedidosEstadoSolicitud = this.selectedPedidos.map((pedido) => {
        const pedidoEstadoSolicitud = { ...pedido };
        pedidoEstadoSolicitud.solicitud = "En espera...";
        return pedidoEstadoSolicitud;
      });
      this.pedidosConEstadoSolicitud = pedidosEstadoSolicitud;

      this.dialogConfirmarAvanzarVarios = false;
      this.dialogAgregarMensajeroAll = false;
      this.dialogProgresoAvanzarVarios = true;
      this.AvanzandoPedidosBtn = true;

      // for (let i = 0; i < this.pedidosConEstadoSolicitud.length; i++) {
      //   // Cambiar el estado del objeto en el array
      //   this.pedidosConEstadoSolicitud[i].solicitud = "Procesando...";

      //   // Simular solicitud al backend esperando 5 segundos
      //   await new Promise((resolve) => setTimeout(resolve, 500));

      //   // Cambiar el estado del objeto en el array
      //   this.pedidosConEstadoSolicitud[i].solicitud = "Completado";

      //   // Imprimir el estado actual después de cambiarlo
      //   console.log(
      //     `Estado cambiado para objeto con id ${this.pedidosConEstadoSolicitud[i].id}: ${this.pedidosConEstadoSolicitud[i].solicitud}`
      //   );
      // }

      // this.AvanzandoPedidosBtn = false; //El btn se activa de nuevo

      try {
        // Creamos un array de promesas utilizando map para hacer una solicitud por cada pedido
        const promesasSolicitudes = this.pedidosConEstadoSolicitud.map(
          async (pedido) => {
            pedido.solicitud = "Procesando...";
            try {
              const avanzado = await this.avanzarPedidoEnArrayPreparado(pedido);
              if (avanzado) {
                pedido.solicitud = "Completado";
              } else {
                pedido.solicitud = "No completado";
              }
            } catch (error) {
              console.error("Error al avanzar pedido:", error);
              pedido.solicitud = "Error";
            }
          },
        );

        // Usamos Promise.allSettled para esperar a que todas las promesas se resuelvan o rechacen
        const resultados = await Promise.allSettled(promesasSolicitudes);

        console.log(resultados);
        this.selectedPedidos = [];

        await this.getPedidos();
        await this.obtenerArregloSucursalesDisponibles();
        this.AvanzandoPedidosBtn = false; //El btn se activa de nuevo
        this.mensajeroParaVariosPreparados = "";
      } catch (error) {
        console.error("Error al avanzar pedidos:", error);
        this.AvanzandoPedidosBtn = false;
        this.mensajeroParaVariosPreparados = "";
      }
    },
    async avanzarRutaEntregaVarios() {
      console.log(this.pedidosConEstadoSolicitud);
      this.dialogUsuariosGPSVarios = false;
      this.dialogProgresoAvanzarVarios = true;
      this.AvanzandoPedidosBtn = true; // Deshabilitar el botón

      // se comprueba el siguiente estado de los pedidos, si es 'en ruta de entrega' se abre un dialog para seleccionar el mensajero para cada pedido
      const siguienteEstado = this.getSiguienteEstado(
        this.pedidosConEstadoSolicitud[0],
      );

      try {
        // Creamos un array de promesas utilizando map para hacer una solicitud por cada pedido
        const promesasSolicitudes = this.pedidosConEstadoSolicitud.map(
          async (pedido) => {
            // pedido.solicitud = "Procesando...";
            try {
              const avanzado = await this.avanzarPedidoEnArray(
                pedido,
                siguienteEstado,
              );
              if (avanzado) {
                pedido.solicitud = "Completado";
              } else {
                pedido.solicitud = "No completado";
              }
            } catch (error) {
              console.error("Error al avanzar pedido:", error);
              pedido.solicitud = "Error";
            }
          },
        );

        // Usamos Promise.allSettled para esperar a que todas las promesas se resuelvan o rechacen
        const resultados = await Promise.allSettled(promesasSolicitudes);

        console.log(resultados);
        this.selectedPedidos = [];

        await this.getPedidos();
        await this.obtenerArregloSucursalesDisponibles();
      } catch (error) {
        console.error("Error al avanzar pedidos:", error);
      }

      this.AvanzandoPedidosBtn = false; // Habilitar el botón
    },
    async avanzarVariosPedidos() {
      console.log("se avanzan los pedidos");
      // se le asigna el estado 'en espera...' a todos los pedidos. Ese estado se ira modificando comforme se avancen los pedidos
      const pedidosEstadoSolicitud = this.selectedPedidos.map((pedido) => {
        const pedidoEstadoSolicitud = { ...pedido };
        pedidoEstadoSolicitud.solicitud = "En espera...";
        return pedidoEstadoSolicitud;
      });
      this.pedidosConEstadoSolicitud = pedidosEstadoSolicitud;

      // se comprueba el siguiente estado de los pedidos, si es 'en ruta de entrega' se abre un dialog para seleccionar el mensajero para cada pedido
      const siguienteEstado = this.getSiguienteEstado(
        pedidosEstadoSolicitud[0],
      );
      if (siguienteEstado.value == "en_ruta_de_entrega") {
        // Utilizar el método filter para obtener un nuevo array con usuarios cuya sucursal sea la del pedido
        const mensajerosArray = this.usuarios.filter(
          (usuario) =>
            usuario.sucursal === pedidosEstadoSolicitud[0].sucursal &&
            usuario.gps !== null,
        );
        console.log(mensajerosArray);

        this.mensajeros = mensajerosArray.map((mensajero) => ({
          text: mensajero.nombre,
          value: mensajero.id,
        }));

        this.dialogConfirmarAvanzarVarios = false;
        this.dialogUsuariosGPSVarios = true;
      } else {
        this.dialogConfirmarAvanzarVarios = false;
        this.dialogProgresoAvanzarVarios = true;
        this.AvanzandoPedidosBtn = true;

        // for (let i = 0; i < this.pedidosConEstadoSolicitud.length; i++) {
        //   // Cambiar el estado del objeto en el array
        //   this.pedidosConEstadoSolicitud[i].solicitud = "Procesando...";

        //   // Simular solicitud al backend esperando 5 segundos
        //   await new Promise((resolve) => setTimeout(resolve, 500));

        //   // Cambiar el estado del objeto en el array
        //   this.pedidosConEstadoSolicitud[i].solicitud = "Completado";

        //   // Imprimir el estado actual después de cambiarlo
        //   console.log(
        //     `Estado cambiado para objeto con id ${this.pedidosConEstadoSolicitud[i].id}: ${this.pedidosConEstadoSolicitud[i].solicitud}`
        //   );
        // }

        try {
          // Creamos un array de promesas utilizando map para hacer una solicitud por cada pedido
          const promesasSolicitudes = this.pedidosConEstadoSolicitud.map(
            async (pedido) => {
              pedido.solicitud = "Procesando...";
              try {
                const avanzado = await this.avanzarPedidoEnArray(
                  pedido,
                  siguienteEstado,
                );
                if (avanzado) {
                  pedido.solicitud = "Completado";
                } else {
                  pedido.solicitud = "No completado";
                }
              } catch (error) {
                console.error("Error al avanzar pedido:", error);
                pedido.solicitud = "Error";
              }
            },
          );

          // Usamos Promise.allSettled para esperar a que todas las promesas se resuelvan o rechacen
          const resultados = await Promise.allSettled(promesasSolicitudes);

          console.log(resultados);
          this.selectedPedidos = [];

          await this.getPedidos();
          await this.obtenerArregloSucursalesDisponibles();
          if (siguienteEstado.value === "entregado") {
            this.$emit("pedidoEntregado");
          }
          this.AvanzandoPedidosBtn = false; //El btn se activa de nuevo
        } catch (error) {
          console.error("Error al avanzar pedidos:", error);
          this.AvanzandoPedidosBtn = false;
        }
      }
    },
    /* Metodo que se utiliza en avanzarVariosPedidos dentro de un ciclo para ir avanzando varios pedidos uno tras otro, regresa true si se avanza el pedido y false si hubo un error
      esto para que se pueda mostrar un icono dependiendo si se avanzo el pedido o no */
    async avanzarPedidoEnArray(pedido, nuevoEstado) {
      /* Si el estado actual del pedido es revision de credito, su siguiente estado es confirmacion,
        se hace directamente ya que el estado revision de credito no se encuentra en el orden de estados */
      if (pedido.estado === "Revisión de crédito") {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=confirmacion`,
          );
          console.log(response.data);
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          // await this.getPedidos();
          // await this.obtenerArregloSucursalesDisponibles();
          // if (nuevoEstado.value === "entregado") {
          //   this.$emit("pedidoEntregado");
          // }
          this.dialogConfirmarAvanzar = false;
          return true;
        } catch (error) {
          if (error.response.status === 401) {
            console.error(error.response);
          } else {
            console.error(error.response);
          }
          return false;
        }
      }
      //Si el siguiente estado del pedido es en_ruta_de_entrega, se tiene que agregar el mensajero en la solicitud
      else if (nuevoEstado.value == "en_ruta_de_entrega") {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=en_ruta_de_entrega&mensajero_id=${pedido.nuevoMensajero}`, //nuevoMensajero se asigna en dialogUsuariosGPSVarios
          );
          console.log(response.data);
          // alert("Pedido avanzado");
          // location.reload();
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          // await this.getPedidos();
          // await this.obtenerArregloSucursalesDisponibles();
          // if (nuevoEstado.value === "entregado") {
          //   this.$emit("pedidoEntregado");
          // }
          this.dialogConfirmarAvanzar = false;
          // this.$emit("pedidoModificado");
          return true;
        } catch (error) {
          if (error.response.status === 401) {
            console.error(error.response);
          } else {
            console.error(error.response);
          }
          this.dialogConfirmarAvanzar = false;
          return false;
        }
      } else {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=${nuevoEstado.value}`,
          );
          console.log(response.data);
          // alert("Pedido avanzado");
          // location.reload();
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          // await this.getPedidos();
          // await this.obtenerArregloSucursalesDisponibles();
          // if (nuevoEstado.value === "entregado") {
          //   this.$emit("pedidoEntregado");
          // }
          this.dialogConfirmarAvanzar = false;
          // this.$emit("pedidoModificado");
          return true;
        } catch (error) {
          console.error(error.response);
          this.dialogConfirmarAvanzar = false;
          return false;
        }
      }
    },
    async avanzarPedidoEnArrayPreparado(pedido) {
      //this.mensajeroParaVariosPreparado contiene el mensajero que se le asiganra a todos los pedidos seleccionados
      try {
        const response = await axios.post(
          `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=en_ruta_de_entrega&mensajero_id=${this.mensajeroParaVariosPreparados}`, //mensajeroParaVariosPreparado se asigna en dialogAgregarMensajeroAll
        );
        console.log(response.data);
        return true;
      } catch (error) {
        if (error.response.status === 401) {
          console.error(error.response);
        } else {
          console.error(error.response);
        }
        return false;
      }
    },
    confirmarAvanzarPedido(pedido) {
      // Comprobamos si el pedido que se quiere avanzar esta en el array de selectedPedidos
      const index = this.selectedPedidos.findIndex(
        (objeto) => objeto.id === pedido.id,
      );

      // Si el pedido que se intenta avanzar existe en el array de selectedPedidos
      if (index !== -1) {
        //si hay mas de un pedido seleccionado se intentan avanzar juntos
        if (this.selectedPedidos.length > 1) {
          //se comprueba si todos los pedidos tienen el mismo estado
          if (this.pedidosMismoEstado(this.selectedPedidos)) {
            this.dialogConfirmarAvanzarVarios = true;
          }
          // al menos un pedido no tiene el mismo estado
          else {
            alert(
              "Todos los pedidos seleccionados deben tener el mismo estado para poder avanzarlos",
            );
          }
        }
        //si solo hay un pedido seleccionado se avanza normalmente
        else if (this.selectedPedidos.length === 1) {
          this.pedidoAvanzar = pedido;
          this.dialogConfirmarAvanzar = true;
        }
      }
      // Si no existe en el array de selectedPedidos, se intenta avanzar individualmente
      else {
        this.pedidoAvanzar = pedido;
        this.dialogConfirmarAvanzar = true;
      }
    },
    /* Verifica si todos los pedidos del array tienen el mismo estado */
    pedidosMismoEstado(pedidos) {
      // Si el array de pedidos está vacío, retornamos true
      if (pedidos.length === 0) {
        return true;
      }

      // Obtenemos el estado del primer pedido
      const primerEstado = pedidos[0].estado;

      // Verificamos si todos los estados son iguales al primer estado
      return pedidos.every((pedido) => pedido.estado === primerEstado);
    },
    currentItems: function (value) {
      this.itemsActuales = value;
      // console.log(this.itemsActuales);
    },
    filtrarItems() {
      const criterioBusqueda = this.search.toLowerCase();

      this.itemsFiltrados = this.itemsActuales.filter((item) => {
        // Aplica aquí tu lógica de filtrado según tus necesidades
        for (let prop in item) {
          const valor = item[prop];

          if (
            typeof valor === "string" &&
            valor.toLowerCase().includes(criterioBusqueda)
          ) {
            return true; // Si alguna propiedad coincide, se incluye el item en los resultados
          } else if (
            typeof valor === "number" &&
            valor.toString().toLowerCase().includes(criterioBusqueda)
          ) {
            return true; // Si el valor numérico coincide, se incluye el item en los resultados
          }
        }
        return false;
      });
    },
    async getComentarios() {
      let arrayFiltrado = [];

      if (this.itemsFiltrados.length === 0) {
        arrayFiltrado = this.itemsNombre[this.selectedTab].pedidos;
      } else {
        arrayFiltrado = this.itemsFiltrados;
      }

      try {
        // Creamos un array de promesas utilizando map para hacer una solicitud por cada pedido
        const promesasSolicitudes = arrayFiltrado.map(async (pedido) => {
          const response = await axios.get(
            `/varios/get_comentarios?id_objeto=${pedido.id}&tipo_objeto=pedido`,
          );

          const comentarios = response.data;

          // Verifica si hay comentarios con más de un minuto de antigüedad
          const currentDate = new Date();
          if (comentarios.length > 0) {
            const ultimoComentario = comentarios[0];
            const fechaComentario = new Date(ultimoComentario.fecha_creacion);
            const diffMs = currentDate - fechaComentario;
            const diffMins = Math.floor(diffMs / (1000 * 60));
            //si el ultimo comentario tiene mas de un minuto, marcar el pedido como necesit revision
            const necesitaRevision = diffMins > 1;
            this.$set(pedido, "necesitaRevision", necesitaRevision);
          } else {
            //si no hay comentarios, marcar el pedido como no necesita revision
            this.$set(pedido, "necesitaRevision", false);
          }
          console.log(pedido.necesitaRevision);
          return comentarios;
          //return response.data; // Aquí puedes retornar la data específica que necesitas del response
        });

        // Resolvemos todas las promesas utilizando Promise.all
        const resultados = await Promise.all(promesasSolicitudes);

        // con resultados.flat() haces que el array sea de nivel 1 para no tener todos los comentarios anidados
        // console.log(resultados.flat());
        return resultados.flat();
      } catch (error) {
        console.error("Error al obtener los comentarios:", error);
      }
    },
    async getLocalizacion(idCliente) {
      try {
        // Creamos un array de promesas utilizando map para hacer una solicitud por cada pedido

        const response = await axios.get(`/reportes/localizacion/${idCliente}`);
        return response.data; // Aquí puedes retornar la data específica que necesitas del response
      } catch (error) {
        console.error("Error al obtener localizacion:", error);
        return {
          latitud: "",
          longitud: "",
        };
      }
    },
    filtrarComentariosPorIdObjeto(idObjeto, arrayComentarios) {
      // Utilizamos el método 'filter' para obtener los comentarios que coinciden con 'id_objeto'
      const comentariosFiltrados = arrayComentarios.filter(
        (comentario) => comentario.id_objeto === idObjeto,
      );

      return comentariosFiltrados;
    },

    async actualizarPedidosARuta(ultimoFormato) {
      /*
        // Recuperar el último formato guardado
        const ultimoFormato = this.formatosImpresionGuardados.at(-1);*/

      if (!ultimoFormato || !ultimoFormato.pedidosPreparadosIDs) {
        alert("No se encontraron pedidos preparados en el formato.");
        return;
      }

      const pedidosPreparadosIDs = ultimoFormato.pedidosPreparadosIDs;
      console.log("Pedidos preparados:", pedidosPreparadosIDs);

      const idMensajero = ultimoFormato.idMensajero;
      console.log("Mensajero ID:", idMensajero);

      try {
        // Enviar los pedidos preparados a "ruta de entrega"
        await this.cambiarPedidosARuta(pedidosPreparadosIDs, idMensajero);
      } catch (error) {
        console.error("Error al enviar pedidos:", error);
        alert("Hubo un error al enviar los pedidos. Revisa la consola.");
      }
    },
    async cambiarPedidosARuta(pedidosPreparadosIDs, idMensajero) {
      let todosEnRuta = true;
      let errores = false;
      let mensajeExito = false;

      if (pedidosPreparadosIDs.length === 0) {
        alert(
          "Solo los pedidos preparados se pueden enviar a ruta de entrega.",
        );
        return;
      }

      for (let idPedido of pedidosPreparadosIDs) {
        try {
          await axios.post("/pedidos/avanzar_pedido", null, {
            params: {
              id_pedido: idPedido, // ID del pedido preparado
              nuevo_estado: "en_ruta_de_entrega", // Estado deseado
              mensajero_id: idMensajero, // ID del mensajero
            },
          });
          mensajeExito = true;
          console.log(`Pedido ${idPedido} cambiado a ruta de entrega.`);
        } catch (error) {
          if (error.response && error.response.status === 400) {
            const errorMessage = error.response.data.detail;

            if (errorMessage.includes("Estado Actual: en_ruta_de_entrega")) {
              continue;
            } else {
              errores = true;
              console.error(
                `Error al actualizar pedido ${idPedido}:`,
                error.response?.data || error.message,
              );
            }
          } else {
            errores = true;
            console.error("Error desconocido:", error);
          }
        }
      }

      if (mensajeExito) {
        alert(
          "Todos los pedidos preparados han sido enviados a la ruta de entrega exitosamente.",
        );
      } else if (todosEnRuta) {
        alert("Todos estos pedidos preparados ya estan en ruta de entrega.");
      }

      if (errores) {
        alert("Hubo un error al enviar los pedidos.");
      }
    },

    async obtenerDatosSucursales() {
      try {
        const response = await axios.get(`/varios/get_json?nombre=sucursales`);
        this.sucursalesDirecciones = response.data.objeto;
        //console.log(this.sucursalesDirecciones);
      } catch (error) {
        console.error("Error al obtener los datos de las sucursales", error);
      }
    },
    async verificarLocalizaciones() {
      this.pedidosConLocalizacion = [];
      this.pedidosSinLocalizacion = [];
      let arrayFiltrado = this.itemsNombre[this.selectedTab].pedidos;

      //itemsFitrados contiene los pedidos que se muestran en la tabla
      if (this.itemsFiltrados.length === 0) {
        arrayFiltrado = this.itemsFiltrados;
      }

      // Se obtienen las localizaciones de todos los pedidos y se les asigna latitud y longitud
      const arrayLocalizaciones = await Promise.all(
        arrayFiltrado.map(async (item) => {
          const localizacion = item.localizacion || {};
          const nuevoItem = {
            id: item.id,
            estado: item.estado,
            fecha_creacion: this.formatoFecha(item.fecha_creacion),
            cliente: item.cliente,
            facturas: item.facturas.join("/"), // Unir las facturas en una sola cadena
            zona: localizacion.zona,
            latitud: localizacion.latitud || "",
            longitud: localizacion.longitud || "",
            direccion:
              localizacion.direccion_linea_1 +
              ", " +
              localizacion.direccion_linea_2,
            codigo_postal: localizacion.codigo_postal,
            ciudad: localizacion.ciudad,
            descripcion: localizacion.descripcion || "",
            mensajero: item.mensajero,
            entregado: "",
            comentarios: "",
          };
          return nuevoItem;
        }),
      );

      // console.log(arrayLocalizaciones);

      // Se filtran los pedidos con localizacion
      this.pedidosConLocalizacion = arrayLocalizaciones.filter((pedido) => {
        // Verificas si la propiedad 'latitud' existe y no está vacía (si tiene latitud entonces tambien tiene longitud)
        if (
          pedido.latitud !== undefined &&
          pedido.latitud !== null &&
          pedido.latitud !== ""
        ) {
          return true; // Mantienes el objeto en el array original
        } else {
          this.pedidosSinLocalizacion.push(pedido); // Agregas el objeto al array de eliminados
          return false; // Eliminas el objeto del array original
        }
      });

      console.log(this.pedidosConLocalizacion);
      console.log(this.pedidosSinLocalizacion);

      if (
        this.pedidosSinLocalizacion.length > 0 &&
        this.pedidosConLocalizacion.length > 0
      ) {
        this.dialogPedidosSinLocalizacion = true;
      } else if (
        this.pedidosSinLocalizacion.length === 0 &&
        this.pedidosConLocalizacion.length > 0
      ) {
        this.exportToCSV(this.pedidosConLocalizacion);
      } else if (this.pedidosConLocalizacion.length === 0) {
        alert("No hay pedidos con localizacion asignada");
      }
    },

    formatoPrecio(numero) {
      // Agregar console.log para ver qué valor está entrando
      //console.log("Número recibido:", numero);

      try {
        // Verificar si el número es válido
        if (isNaN(numero)) {
          console.error(
            "El valor proporcionado no es un número válido:",
            numero,
          );
          return "$0.00";
        }

        const numeroPrecio = parseFloat(numero);
        const precio = numeroPrecio.toFixed(2); // Limitar a 2 decimales
        const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
        const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

        // Formatear la parte entera con separador de miles
        const parteEnteraFormateada = parteEntera.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ",",
        );

        return `${parteEnteraFormateada}${separadorDecimal}${parteDecimal}`;
      } catch (error) {
        console.error("Error al formatear el número:", error);
        return "$0.00"; // En caso de error, devolver un valor por defecto
      }
      /*// Formatear el número utilizando una función personalizada
        const numeroPrecio = parseFloat(numero);
        const precio = numeroPrecio.toFixed(2); // Limitar a 2 decimales
        const separadorDecimal = precio.indexOf(".") !== -1 ? "." : "";
        const [parteEntera, parteDecimal] = precio.split(separadorDecimal);

        // Formatear la parte entera con separador de miles
        const parteEnteraFormateada = parteEntera.replace(
          /\B(?=(\d{3})+(?!\d))/g,
          ","
        );

        return `${parteEnteraFormateada}${separadorDecimal}${parteDecimal}`;*/
    },
    async pedidoModificado() {
      await this.getPedidos(); //Se solicitan los pedidos para actualizar la tabla sin tener que recargar la view completa
      await this.obtenerArregloSucursalesDisponibles();
      // this.$emit("pedidoModificado");
    },
    getSiguienteEstado(pedido) {
      if (!pedido || !pedido.estado) {
        return null;
      }

      if (pedido.estado === "Revisión de crédito") {
        return this.ordenEstados[1]; //Si esta en revision de credito regresa el estado de Confirmacion
      }

      const estadoEncontrado = this.ordenEstados.find(
        (estado) => estado.text === pedido.estado,
      );

      if (estadoEncontrado !== undefined) {
        const indice = this.ordenEstados.indexOf(estadoEncontrado);
        return this.ordenEstados[indice + 1];
      }
      return null; // Si no se encuentra el estado o es el último, retorna null
    },

    getSiguienteEstadoTexto(pedido) {
      const siguienteEstado = this.getSiguienteEstado(pedido);
      return siguienteEstado === "Facturación"
        ? siguienteEstado.text
        : "Facturación";
    },

    async avanzarRutaEntrega() {
      try {
        const response = await axios.post(
          `/pedidos/avanzar_pedido?id_pedido=${this.pedidoEnRuta.id}&nuevo_estado=en_ruta_de_entrega&mensajero_id=${this.mensajero}`, //this.mensajero contiene solo el id del mensajero
        );
        console.log(response.data);
        alert("Pedido avanzado");
        // location.reload();
        await this.getPedidos(); //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
        await this.obtenerArregloSucursalesDisponibles();
        this.$emit("pedidoModificado");
        this.dialogUsuariosGPS = false;
      } catch (error) {
        console.error(error.response);
        alert(error.response.data.detail[0].msg);
        this.dialogUsuariosGPS = false;
      }
    },

    async avanzarPedidoFacturacion() {
      const pedido = this.pedidoSeleccionado;
      if (
        pedido.estado === "confirmacion" ||
        pedido.estado === "Confirmación"
      ) {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=facturacion`,
          );
          console.log(response.data);
          alert("Pedido avanzado");
          // location.reload();
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          await this.getPedidos();
          await this.obtenerArregloSucursalesDisponibles();
          this.$emit("pedidoModificado");
          this.dialogConfirmarAvanzar = false;
          this.abrirDetallesPreparacion = false;
        } catch (error) {
          if (error.response.status === 401) {
            console.error(error.response);
            alert("No permitido\n" + error.response.data.detail);
          } else {
            console.error(error.response);
            alert(error.response.data.detail[0].msg);
          }
          this.dialogConfirmarAvanzar = false;
          this.abrirDetallesPreparacion = false;
        }
      }
    },
    async avanzarPedido(pedido) {
      const nuevoEstado = this.getSiguienteEstado(pedido);
      if (pedido.estado === "Revisión de crédito") {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=confirmacion`,
          );
          console.log(response.data);
          alert("Pedido avanzado");
          // location.reload();
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          await this.getPedidos();
          await this.obtenerArregloSucursalesDisponibles();
          await this.generarComentariosProductos();
          if (nuevoEstado.value === "entregado") {
            this.$emit("pedidoEntregado");
          }
          this.dialogConfirmarAvanzar = false;
          this.abrirDetallesPreparacion = false;
          // this.$emit("pedidoModificado");
        } catch (error) {
          if (error.response.status === 401) {
            console.error(error.response);
            alert("No permitido\n" + error.response.data.detail);
          } else {
            console.error(error.response);
            alert("Error al avanzar el pedido\n" + error.response.data.detail);
          }
          this.dialogConfirmarAvanzar = false;
          this.abrirDetallesPreparacion = false;
        }
      }
      //Si el siguiente estado del pedido es en_ruta_de_entrega, se abre un dialogo para seleccionar el mensajero
      else if (nuevoEstado.value == "en_ruta_de_entrega") {
        this.pedidoEnRuta = pedido;

        // Utilizar el método filter para obtener un nuevo array con usuarios cuya sucursal sea la del pedido
        const mensajerosArray = this.usuarios.filter(
          (usuario) =>
            usuario.sucursal === pedido.sucursal && usuario.gps !== null,
        );
        console.log(mensajerosArray);

        this.mensajeros = mensajerosArray.map((mensajero) => ({
          text: mensajero.nombre,
          value: mensajero.id,
        }));

        this.dialogConfirmarAvanzar = false;
        this.abrirDetallesPreparacion = false;
        this.dialogUsuariosGPS = true;
      } else {
        try {
          const response = await axios.post(
            `/pedidos/avanzar_pedido?id_pedido=${pedido.id}&nuevo_estado=${nuevoEstado.value}`,
          );
          console.log(response.data);
          alert("Pedido avanzado");
          // location.reload();
          //Se solicitan los pedidos para actualizar la tabla sin tener que recargar toda la view completa
          await this.getPedidos();
          await this.obtenerArregloSucursalesDisponibles();
          if (nuevoEstado.value === "entregado") {
            this.$emit("pedidoEntregado");
          }
          this.dialogConfirmarAvanzar = false;
          this.abrirDetallesPreparacion = false;
          // this.$emit("pedidoModificado");
        } catch (error) {
          if (error.response.status === 401) {
            console.error(error.response);
            alert("No permitido\n" + error.response.data.detail);
          } else {
            console.error(error.response);
            alert(error.response.data.detail);
          }
          this.dialogConfirmarAvanzar = false;
          this.abrirDetallesPreparacion = false;
        }
      }
    },
    crearListaDiscrepancias(stringDiscrepancias) {
      const discrepanciasList = stringDiscrepancias.split(",");
      return discrepanciasList;
    },
    obtenerArregloSucursalesDisponibles() {
      console.log(this.itemsPedidos);
      const nuevoArreglo = this.itemsPedidos.sort((a, b) => {
        const indiceA = this.ordenSucursales.indexOf(a.sucursal);
        const indiceB = this.ordenSucursales.indexOf(b.sucursal);
        return indiceA - indiceB;
      });
      this.itemsSucursalesDisponibles = nuevoArreglo;
    },
    getNombreVendedor(vendedorId) {
      const vendedorEncontrado = this.usuarios.find(
        (usuario) => usuario.id === vendedorId,
      );
      if (vendedorEncontrado) {
        return vendedorEncontrado.nombre + " ";
      }
      return "";
    },
    getNombreCliente(clienteId) {
      const clienteEncontrado = this.clientes.find(
        (cliente) => cliente.id === clienteId,
      );
      if (clienteEncontrado) {
        return clienteEncontrado.razon_social + " ";
      }
      return "";
    },
    getZonaCliente(clienteId) {
      const clienteEncontrado = this.clientes.find(
        (cliente) => cliente.id === clienteId,
      );
      if (clienteEncontrado) {
        if (clienteEncontrado.zona) {
          return clienteEncontrado.zona + " ";
        }
      }
      return "";
    },
    /**Busca el cliente por id en el arreglo de clientes y retorna su informacion */
    getInfoCliente(clienteId) {
      const clienteEncontrado = this.clientes.find(
        (cliente) => cliente.id === clienteId,
      );
      if (clienteEncontrado) {
        return clienteEncontrado;
      }
      return null;
    },
    getAntiguedad(fecha_creacion) {
      const now = new Date();
      const fecha = new Date(fecha_creacion);
      const diffMs = now - fecha;
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const diffHrs = Math.floor(
        (diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

      if (diffDays > 0) {
        return `${diffDays} día${diffDays > 1 ? "s" : ""}`;
      } else if (diffHrs > 0) {
        return `${diffHrs} hora${diffHrs > 1 ? "s" : ""}`;
      } else if (diffMins > 0) {
        return `${diffMins} minuto${diffMins > 1 ? "s" : ""}`;
      } else {
        return `menos de un minuto`;
      }
    },
    async getPedidos() {
      try {
        const response = await axios.get(`/pedidos/get_abiertos`);
        this.itemsPedidos = response.data;
        const ordenadarPedidosPorAntiguedad = this.itemsPedidos.sort(
          (a, b) =>
            new Date(b.fecha_creacion).getTime() -
            new Date(a.fecha_creacion).getTime(),
        );
        this.itemsPedidos = ordenadarPedidosPorAntiguedad;
        this.$emit("pedidosActualizados", this.itemsPedidos); //Se envian los pedidos actualizados a la vista de PedidosView
      } catch (error) {
        console.error(error);
      }
    },
    formatoFecha(fechaOriginal) {
      // Fecha en el formato original

      // Crear un objeto Date a partir de la fecha original
      const fecha = new Date(fechaOriginal);

      // Obtener los componentes de la fecha
      const year = fecha.getFullYear();
      const month = ("0" + (fecha.getMonth() + 1)).slice(-2); // Agrega un cero inicial si es necesario
      const day = ("0" + fecha.getDate()).slice(-2); // Agrega un cero inicial si es necesario

      // Construir la fecha en el formato deseado
      const fechaFormateada = `${day}-${month}-${year}`;

      return fechaFormateada; // Resultado: '01-06-2023'
    },
    getFechaLegible(fechaOriginal) {
      const fecha = new Date(fechaOriginal);

      const año = fecha.getFullYear();
      const mes = fecha.getMonth() + 1;
      const dia = fecha.getDate();
      const hora = fecha.getHours();
      const minutos = fecha.getMinutes().toString().padStart(2, "0");

      const fechaLegible = `${dia}/${mes}/${año}`;
      const horaLegible = `${hora}:${minutos}`;

      return `${fechaLegible} ${horaLegible}`;
    },
    async getComentariosNuevos(periodo) {
      const currentDate = new Date();
      let fechaComentarios = "";

      switch (periodo) {
        case 1:
          fechaComentarios = format(
            subMinutes(currentDate, 15),
            "yyyy-MM-dd HH:mm:ssXX",
          );
          break;
        case 2:
          fechaComentarios = format(
            subHours(currentDate, 1),
            "yyyy-MM-dd HH:mm:ssXX",
          );
          break;
        case 3:
          fechaComentarios = format(
            subHours(currentDate, 4),
            "yyyy-MM-dd HH:mm:ssXX",
          );
          break;
        case 4:
          fechaComentarios = format(
            subHours(currentDate, 8),
            "yyyy-MM-dd HH:mm:ssXX",
          );
          break;
        case 5:
          fechaComentarios = format(
            subHours(currentDate, 12),
            "yyyy-MM-dd HH:mm:ssXX",
          );
          break;
        default:
          fechaComentarios = format(currentDate, "yyyy-MM-dd HH:mm:ssXX");
          break;
      }

      try {
        const response = await axios.get(
          `/varios/get_comentarios_nuevos?tipo_objeto=pedido&fecha=${fechaComentarios}`,
        );
        this.arrayComentariosNuevos = response.data;
        this.dialogComentarios = false;
      } catch (error) {
        console.error(error);
        this.dialogComentarios = false;
      }
    },
    verCantidadPedidos() {
      // console.log(this.selectedItems);

      const estados = [
        "Pedido creado",
        "Revisión de crédito",
        "Confirmación",
        "Facturación",
        "Preparación en almacén",
        "Preparado",
        "En ruta de entrega",
      ];

      const contadores = estados.map((estado) => {
        return this.selectedItems.reduce((acumulador, pedido) => {
          return acumulador + (pedido.estado === estado ? 1 : 0);
        }, 0);
      });

      this.chartSeries = [
        {
          name: "Cantidad",
          data: contadores,
        },
      ];

      // console.log(contadores);
      this.dialogPedidos = true;
    },

    formatearTexto(texto) {
      if (!texto) return "";

      const str = String(texto);
      const partes = str.split("_");

      // Casos especiales para patrones como "Mexicali_san_luis"
      if (partes.length >= 3 && partes[1] === "san" && partes[2] === "luis") {
        return "San Luis";
      }

      // Caso específico directo
      if (texto === "san_luis") return "San Luis";

      // Comportamiento por defecto: tomar la segunda parte
      return partes[1] || "";
    },
  },
  computed: {
    ...mapGetters(["user", "currentUser"]),
    getFilteredUsuarios() {
      return this.usuarios.filter((user) => {
        return user.nombre_adminpaq !== null;
      });
    },
    // Obtiene el día actual de la semana
    currentDay() {
      const days = [
        "DOMINGO",
        "LUNES",
        "MARTES",
        "MIERCOLES",
        "JUEVES",
        "VIERNES",
        "SABADO",
      ];
      const today = new Date();
      return days[today.getDay()];
    },
    todosMensajerosSeleccionados() {
      // Verifica si todos los pedidos tienen un nuevo mensajero seleccionado
      const seleccionados = this.pedidosConEstadoSolicitud.every(
        (pedido) =>
          pedido.nuevoMensajero !== null && pedido.nuevoMensajero !== undefined,
      );
      // console.log(seleccionados);
      return seleccionados;
    },
    itemsNombre() {
      return this.itemsSucursalesDisponibles.map((sucursal) => {
        const pedidos = sucursal.pedidos.map((pedido) => {
          const nuevoPedido = { ...pedido };
          const infoCliente = this.getInfoCliente(pedido.cliente); //se almacena la informacion del cliente
          nuevoPedido.vendedor = this.getNombreVendedor(pedido.vendedor);
          nuevoPedido.creado_por = this.getNombreVendedor(pedido.creado_por);
          nuevoPedido.mensajero = this.getNombreVendedor(pedido.mensajero);
          nuevoPedido.idCliente = pedido.cliente;
          // nuevoPedido.cliente = this.getNombreCliente(pedido.cliente);
          // nuevoPedido.zona = this.getZonaCliente(pedido.cliente);

          if (infoCliente) {
            nuevoPedido.cliente = infoCliente.razon_social + " ";
            if (infoCliente.zona) {
              nuevoPedido.zona = infoCliente.zona + " ";
            } else {
              nuevoPedido.zona = "";
            }
          } else {
            nuevoPedido.cliente = "";
            nuevoPedido.zona = "";
          }

          if (pedido.facturas) {
            if (pedido.facturas[0] === null) {
              nuevoPedido.facturas = [];
            }
          } else {
            nuevoPedido.facturas = [];
          }

          // if (pedido.serie_factura && pedido.folio_factura) {
          //   nuevoPedido.serie_folio =
          //     pedido.serie_factura + " " + pedido.folio_factura;
          // }
          if (pedido.discrepancias === null) {
            nuevoPedido.discrepancias = "Sin discrepancias";
          }
          if (pedido.contado) {
            nuevoPedido.pago = "Contado";
          } else {
            nuevoPedido.pago = "Crédito";
          }
          let estado = pedido.estado;
          switch (estado) {
            case "pedido_creado":
              estado = "Pedido creado";
              break;
            case "revision_de_credito":
              estado = "Revisión de crédito";
              break;
            case "confirmacion":
              estado = "Confirmación";
              break;
            case "facturacion":
              estado = "Facturación";
              break;
            case "preparacion_en_almacen":
              estado = "Preparación en almacén";
              break;
            case "preparado":
              estado = "Preparado";
              break;
            case "en_ruta_de_entrega":
              estado = "En ruta de entrega";
              break;
            case "entregado":
              estado = "Entregado";
              break;
            case "cancelado":
              estado = "Cancelado";
              break;
            default:
          }
          nuevoPedido.estado = estado;
          return nuevoPedido;
        });

        //Para colocar los pedidos con prioridad primero
        // Usamos sort() junto con un comparador personalizado
        pedidos.sort((a, b) => {
          // Primero, verificamos si 'a' tiene prioridad y 'b' no
          if (a.prioridad && !b.prioridad) {
            return -1; // 'a' va antes que 'b'
          }

          // Segundo, verificamos si 'b' tiene prioridad y 'a' no
          if (!a.prioridad && b.prioridad) {
            return 1; // 'b' va antes que 'a'
          }

          // En caso de que ambos tengan la misma prioridad o ambos no tengan prioridad,
          // se mantiene el orden actual.
          return 0;
        });

        // console.log(pedidos);
        return { ...sucursal, pedidos };
      });
    },
    selectedItems() {
      this.filtrarItems();
      let pedidos;
      if (this.selectedTab >= 1 && this.selectedTab <= 6) {
        pedidos = this.itemsNombre[this.selectedTab].pedidos;
      } else {
        pedidos = this.itemsNombre[this.selectedTab].pedidos || [];
      }
      // Ordenar por fecha de creación descendente
      return pedidos.sort(
        (b, a) => new Date(b.fecha_creacion) - new Date(a.fecha_creacion),
      );
    },
    itemRowBackgroundPrioridad() {
      return (item) => {
        const estado = item.estado;
        //const prioridad = item.prioridad;
        //const necesita_Revision = item.necesitaRevision;
        let classes = "";

        /*if (necesita_Revision) {
          classes += "";
        } else {*/
        switch (estado) {
          case "Cancelado":
            classes += "red lighten-4";
            break;
          case "Revisión de crédito":
            classes += "deep-purple lighten-4";
            break;
          case "Facturación":
            classes += "teal lighten-4";
            break;
          case "En ruta de entrega":
            classes += "yellow lighten-4";
            break;
          case "Preparación en almacén":
            classes += "orange lighten-4";
            break;
          case "Preparado":
            classes += "blue lighten-4";
            break;
          case "Pedido creado":
            classes += "green lighten-4";
            break;
          case "Confirmación":
            classes += "light-green lighten-4";
            break;
          case "Entregado":
            classes += "indigo lighten-4";
            break;
          default:
            classes += "";
            break;
        }
        //}

        //console.log(`Pedido ID: ${item.id}, Clases: ${classes}`);
        return classes.trim(); // Elimina espacios en blanco al principio y al final
      };
    },
    itemRowBackground() {
      return (item) => {
        const estado = item.estado;
        switch (estado) {
          case "Cancelado":
            return "red lighten-4";
          case "Facturación":
            return "teal lighten-4";
          case "Revisión de crédito":
            return "deep-purple lighten-4";
          case "En ruta de entrega":
            return "yellow lighten-4";
          case "Preparación en almacén":
            return "orange lighten-4";
          case "Preparado":
            return "blue lighten-4";
          case "Pedido creado":
            return "green lighten-4";
          case "Confirmación":
            return "light-green lighten-4";
          case "Entregado":
            return "indigo lighten-4";
          default:
            return "";
        }
      };
    },

    todosProductosEscaneados() {
      const productos =
        this.pedidoSeleccionado?.productos.lista_productos || {};
      const codigos = Object.keys(productos);
      if (codigos.length === 0) {
        return false; // No hay productos escaneados
      }

      return codigos.every(
        (codigo) =>
          productos[codigo].confirmado &&
          productos[codigo].confirmado === productos[codigo].cantidad,
      );
    },
  },
  watch: {
    selectedTab() {
      this.obtenerMensajeroConGps();
      console.log("Cambiando a la sucursal:", this.selectedTab);

      if (this.selectedPedidos.length > 0) {
        this.selectedPedidos = [];
      }
    },

    pedidoSeleccionado: {
      handler(nuevoPedido) {
        if (nuevoPedido && nuevoPedido.id) {
          this.obtenerComentariosDelPedido(nuevoPedido.id);
          this.inicializarProductos();
        }
        console.log("pedidoSeleccionado:", nuevoPedido);
      },
      immediate: true,
    },
  },
  mounted() {
    this.obtenerArregloSucursalesDisponibles();
    this.getComentariosNuevos();
    this.getComentarios();
    //console.log(this.formatoPrecio(10000));
    this.obtenerMensajeroConGps();
    this.obtenerDatosSucursales();
    this.inicializarProductos();
  },
  async created() {
    // Establece un temporizador para llamar a getPedidos() cada cierto intervalo
    this.timer = setInterval(async () => {
      await this.getPedidos();
      await this.obtenerArregloSucursalesDisponibles();
      await this.getComentarios();
    }, 30000); // 30000 milisegundos = 30 segundos
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  components: { AccionesPedido },
};
</script>

<style>
.highlighted-row {
  outline: 2px solid rgb(237, 97, 97); /* Cambie el color y el estilo del borde según sus necesidades */
  box-shadow: inset 2px 0 0 rgb(237, 97, 97), inset -2px 0 0 rgb(237, 97, 97); /* Ajuste el color y tamaño según sus necesidades */
}

.pointer-disabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.4;
}
.neon-warning {
  outline: 2px solid rgb(237, 97, 97);
  animation: glow 1s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    box-shadow: inset 0 0 5px rgb(237, 97, 97);
  }
  to {
    box-shadow: inset 0 0 10px rgb(237, 97, 97);
  }
}
</style>
